import React, { useState, useCallback, useRef } from 'react';
import { StyleSheet } from 'react-native';
import { ListItem, Input, Button, Text } from '@rneui/themed';
import { useJWT } from '@annunciate/core';
import { View } from '@annunciate/ui';
import { Avatar } from './Avatar';
import { useCommentCreateMutation } from '../hooks';
export const CommentForm = ({ discussionId, endpoint, queryKey, id, parentId, onClose: onParentClose = () => { }, onSubmitSuccess = () => { }, }) => {
    const inputRef = useRef(undefined);
    const [body, setBody] = useState();
    const [isCommenting, setIsCommenting] = useState(false);
    const { mutateAsync: create } = useCommentCreateMutation({
        endpoint,
        queryKey,
        parentId,
    });
    const onClose = useCallback(() => {
        setBody(undefined);
        inputRef?.current?.clear();
        onParentClose();
        setIsCommenting(false);
    }, [onParentClose, setBody]);
    const createComment = useCallback(async (discussionId, body, parentId) => {
        try {
            await create({
                discussionId,
                body,
                parentId,
            });
            onSubmitSuccess();
        }
        catch (err) {
            console.log('Error creating comment', err);
        }
    }, [create, onSubmitSuccess]);
    const jwt = useJWT();
    const isLoggedIn = jwt !== undefined ? true : false;
    return (React.createElement(ListItem, { style: { width: '100%' }, containerStyle: { paddingHorizontal: 0 } },
        React.createElement(Avatar, { user: {
                id: jwt?.sub,
                name: jwt?.name,
                picture: jwt?.picture,
            } }),
        React.createElement(ListItem.Content, null,
            isLoggedIn && (React.createElement(Input, { ref: inputRef, value: body, multiline: true, maxLength: 10000, placeholder: "Add a comment...", onChangeText: t => setBody(t), onFocus: () => setIsCommenting(true) })),
            !isLoggedIn && (React.createElement(Text, null, "Please login first.")),
            isLoggedIn && isCommenting && (React.createElement(View, { style: styles.submitCloseContainer },
                React.createElement(Button, { type: "clear", onPress: () => onClose() }, "Cancel"),
                React.createElement(Button, { style: { marginRight: 10 }, onPress: async () => {
                        if (!body)
                            return;
                        await createComment(discussionId, body, parentId);
                        onClose();
                    } }, "Submit"))))));
};
const styles = StyleSheet.create({
    submitCloseContainer: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        width: '100%',
    },
});
//# sourceMappingURL=CommentForm.js.map